module.exports = __webpack_public_path__ + "img/heart.a1cb64ce.gif";